import React from "react";
import Icon from "../Icon";
import { LoadingContainer, LoadingText } from "./styles";

function Loading({ loadingItem = "" ,isLoading}) {
  return <LoadingContainer isLoading={isLoading}>
    <Icon type="loading" size="30px" /> <LoadingText>Loading {loadingItem}...</LoadingText>
  </LoadingContainer>;
}
export default Loading;